import { SCENE, ATLAS, CARDS_DATA } from '../constants/cardsConstants.js';
import FloatingCards from '../FloatingCards.js';

export default class Cards {
  constructor() {
    this.floatingCards = new FloatingCards();
    this.sizes = this.floatingCards.sizes;
    this.camera = this.floatingCards.camera;
    this.cards = Object.entries(CARDS_DATA);
    this.calculateCards();
  }

  resize() {
    this.calculateCards();
  }

  calculateCards() {
    // Use full width for mobile devices (< 768px), otherwise use 90% with max width constraint
    const isMobile = this.sizes.width < 768;
    this.imagesConstellationMaxWidth = isMobile 
      ? this.sizes.width 
      : Math.min(SCENE.MAX_CONSTELLATION_WIDTH, this.sizes.width * 0.9);

    // whole area width
    let totalAreaWidth = 0;
    this.cards.forEach(([key, card], index) => {
      const cardRight = card.world.x + card.frame.w;
      if (cardRight > totalAreaWidth) {
        totalAreaWidth = cardRight;
      }
    })

    // calculate width coef
    let widthCoef = 1;
    if (totalAreaWidth > this.imagesConstellationMaxWidth) {
      widthCoef = this.imagesConstellationMaxWidth / totalAreaWidth;
    }

    const pixelsToSceneUnits = this.camera.pixelsToSceneUnits;

    this.cards.forEach(([key, card], index) => {
      card.adjustedX = card.world.x * widthCoef;
      card.adjustedY = card.world.y * widthCoef;
      card.adjustedWidth = card.frame.w * widthCoef;
      card.adjustedHeight = card.frame.h * widthCoef;
    })

    let totalAreaHeight = 0;
    this.cards.forEach(([key, card], index) => {
      const cardBottom = card.adjustedY + card.adjustedHeight;
      if (cardBottom > totalAreaHeight) {
        totalAreaHeight = cardBottom;
      }
    })

    const areaCenterYScene = -1 * (totalAreaHeight * pixelsToSceneUnits) / 2;
    const areaCenterXScene = -1 * (totalAreaWidth * widthCoef * pixelsToSceneUnits) / 2;

    this.cards.forEach(([key, card], index) => {
      card.positionXScene = areaCenterXScene + (card.adjustedX + card.adjustedWidth / 2) * pixelsToSceneUnits;
      card.positionYScene = areaCenterYScene + (totalAreaHeight - (card.adjustedY + card.adjustedHeight / 2)) * pixelsToSceneUnits;
      card.scaleX = card.adjustedWidth * pixelsToSceneUnits;
      card.scaleY = card.adjustedHeight * pixelsToSceneUnits;
    })
  }
}
